import './index.less'

export default class MembershipRules {
    constructor() {
        this.wrapDOM = document.querySelector('[data-membership-rules-wrap]')
        this.contentDOM = document.querySelector('[data-membership-rules-content]')
        this.viewMoreBtn = document.querySelector('[data-membership-rules-expand-button]')

        if (this.contentDOM) {
            this.init()

            if (this.viewMoreBtn) {
                const debounceResizeHandler = debounce(() => {
                    // 更新 Content 的最大高度
                    if (this.viewMoreBtn.classList.contains('active')) {
                        this.contentDOM.style.maxHeight = this.contentDOM.scrollHeight + 'px'
                    }
                }, 100)
                window.addEventListener('resize', debounceResizeHandler)
            }

            this.observe()
        }
    }
    init() {
        const { scrollHeight, offsetHeight, } = this.contentDOM

        // 如果内容总高度 > 内容显示区高度
        if (scrollHeight > offsetHeight && this.viewMoreBtn) {
            this.viewMoreBtn.classList.remove('hidden')

            this.viewMoreBtn.onclick = async e => {
                const target = e.target.tagName === 'I' ? e.target.parentElement : e.target
                const { viewMoreText, hideText, } = target.dataset

                if (target.classList.contains('active')) {
                    // 滚动到 wrapDOM 顶部
                    const offsetTop = this.wrapDOM.offsetTop
                    const sectionHeight = document.querySelector('[data-sticky-anchor-section]')?.offsetHeight || 0 // anchor 容器的高度

                    window.scrollTo({
                        top: offsetTop - sectionHeight,
                        behavior: 'smooth',
                    })

                    setTimeout(() => {
                        target.classList.remove('active')
                        this.contentDOM.style = ''
                        target.innerHTML = `${viewMoreText} <i class="iconfont jackery-icon-arrow-right inline-block text-42 -mt-3 lg:j-text-25 -lg:j-mt-3 xl:a-text-25 -xl:a-mt-3 rotate-90"></i>`

                        // 更新 ga 埋码文案
                        target.dataset.gaParamsButton_name = viewMoreText
                    }, 200)
                } else {
                    target.classList.add('active')
                    this.contentDOM.style.maxHeight = this.contentDOM.scrollHeight + 'px'
                    target.innerHTML = `${hideText} <i class="iconfont jackery-icon-arrow-right inline-block text-42 -mt-3 lg:j-text-25 -lg:j-mt-3 xl:a-text-25 -xl:a-mt-3 -rotate-90"></i>`

                    setTimeout(() => {
                        // 更新 ga 埋码文案
                        target.dataset.gaParamsButton_name = hideText
                    }, 200)
                }
            }
        }
    }

    observe() {
        const Observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active')
                }
            })
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0,
        })

        const parentDOM = this.wrapDOM
        const targetDOMs = parentDOM.querySelectorAll('[data-animation-dom]')
        if (targetDOMs.length > 0) {
            targetDOMs.forEach(item => Observer.observe(item))
        }
    }
}
